import { render, staticRenderFns } from "./HomeworkItem.vue?vue&type=template&id=b64f467a&scoped=true"
import script from "./HomeworkItem.vue?vue&type=script&lang=ts"
export * from "./HomeworkItem.vue?vue&type=script&lang=ts"
import style0 from "./HomeworkItem.vue?vue&type=style&index=0&id=b64f467a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64f467a",
  null
  
)

export default component.exports